import React, { ReactNode } from 'react'
import classNames from 'classnames'

interface CardGroupProps {
    tag?: React.ElementType
    className?: string
    children?: ReactNode
    [key: string]: any // for other props
}

const CardGroup: React.FC<CardGroupProps> = ({
    tag: Tag = 'div',
    className,
    children,
    ...otherProps
}) => {
    const classes = classNames('card-group', className)
    return <Tag {...otherProps} className={classes}>{children}</Tag>
}

export { CardGroup }
